// extracted by mini-css-extract-plugin
export default {"city":"display_city__eLZhd","address1":"display_address1__N7E5J","address2":"display_address2__+iBoG"};